/** Everything in a query key but the trailing page number. */
function scopeOf(key: readonly unknown[]): string {
  return JSON.stringify(key.slice(0, -1));
}

/**
 * `placeholderData` for a paged list whose query key ends with the page: the
 * previous rows stay on screen while the next page loads, but never stand in
 * for the result of another search, filter or parent entity (those would read
 * as the answer to a question that was not asked).
 */
export function keepRowsWithinScope<TData>(queryKey: readonly unknown[]) {
  return (
    previous: TData | undefined,
    previousQuery?: { readonly queryKey: readonly unknown[] },
  ): TData | undefined =>
    previousQuery && scopeOf(previousQuery.queryKey) === scopeOf(queryKey) ? previous : undefined;
}
